import { FC, useEffect, useState, useMemo } from 'react'
import cn from 'classnames'
import { useAddAlert } from '@/hooks/useAddAlert'
import { crmApi } from '@/api'
import { isError } from '@/helpers/checkQuery'
import Select from '../../../base/Select/Select'
import { useLeadStatuses } from '../../blocks/StatusListBlock/LeadStatusContext'
import { useCRMContext } from '@pages/Admin/CRM/CRMContext'
import classes from './index.module.css'
import useFullLeadModalAccess from '../../hooks/useFullLeadModalAccess'

interface SelectNewStatusProps {
  leadId: number
  className?: string
}

const SelectNewStatus: FC<SelectNewStatusProps> = ({ leadId, className }) => {
  const addAlert = useAddAlert()
  const {
    currentTab,
    preloadingData: { statuses: allStatuses },
  } = useCRMContext()
  const { statuses, loading, refreshStatuses } = useLeadStatuses()
  const { currentRole, ...access } = useFullLeadModalAccess()
  const [valueStatusId, setValueStatusId] = useState<number | null>(null)

  const optionsStatuses = useMemo(() => {
    const currentStatus = allStatuses.find(
      (status) => status.id === valueStatusId,
    )

    const isClientTab = currentTab === 'client'
    const filteredStatuses = allStatuses.filter((status) =>
      isClientTab ? status.for_client : !status.for_client,
    )

    const hasCurrentStatus =
      currentStatus &&
      filteredStatuses.some((status) => status.id === currentStatus.id)

    if (currentStatus && !hasCurrentStatus) {
      return [currentStatus, ...filteredStatuses]
    }

    return filteredStatuses
  }, [allStatuses, statuses, valueStatusId, currentTab])

  useEffect(() => {
    if (statuses.length < 1) {
      setValueStatusId(null)
      return
    }

    setValueStatusId(statuses[0]?.status?.id)
  }, [statuses])

  const handlerSelectStatus = (statusId: number) => {
    crmApi
      .insertLeadStatus({ lead_id: leadId, status_id: statusId })
      .then((res) => {
        if (isError(res)) throw new Error()
        addAlert({
          title: 'Успешно',
          text: `Успешно добавлено статус`,
          type: 'success',
        })
        refreshStatuses()
      })
      .catch(() => {
        addAlert({
          title: 'Ошибка',
          text: 'Ошибка добавлении статуса',
          type: 'error',
        })
      })
  }

  return (
    <Select
      placeholder="Статус"
      className={cn(classes.select, className)}
      value={valueStatusId}
      onChange={(val) => {
        setValueStatusId(val)
        handlerSelectStatus(val)
      }}
      options={optionsStatuses.map((status) => ({
        label: (
          <div className={classes.itemStatusWrapper}>
            <div
              className={classes.itemStatusColor}
              style={{ backgroundColor: status.color }}
            />
            <p className={classes.itemStatusName}>{status.name}</p>
          </div>
        ),
        value: status.id,
      }))}
      loading={loading}
      disabled={!access.canChangeLeadStatus}
      suffixIcon={!access.canChangeLeadStatus ? null : undefined}
    />
  )
}

export default SelectNewStatus
